var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleOverlap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.878,7.122C16.216,3.09,12.717,0,8.5,0,3.813,0,0,3.813,0,8.5c0,4.217,3.09,7.716,7.122,8.378.662,4.032,4.161,7.122,8.378,7.122,4.687,0,8.5-3.813,8.5-8.5,0-4.217-3.09-7.716-7.122-8.378Zm-14.878,1.378c0-3.584,2.916-6.5,6.5-6.5,3.079,0,5.66,2.155,6.327,5.034-4.15.328-7.465,3.643-7.793,7.793-2.879-.667-5.034-3.248-5.034-6.327Zm13.5,13.5c-3.079,0-5.66-2.155-6.327-5.034,4.15-.328,7.465-3.643,7.793-7.793,2.879.667,5.034,3.248,5.034,6.327,0,3.584-2.916,6.5-6.5,6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOverlap);
export default __webpack_public_path__ + "static/media/circle-overlap.610559cce31f7b691cb6d07c8724ba86.svg";
export { ForwardRef as ReactComponent };